// Libs
import React from 'react';
import { Modal } from 'react-bootstrap';
import moment from 'moment';

// Services & Helpers
import BaseService from 'services/BaseService';
import BootboxHelper from 'helpers/BootboxHelper';

// Components
import Loader from 'components/common/Loader';

//-------------------------------------------------------------------------------------------------------------------

class InstructorCredentialsEmailsModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    show(opts) {
        return new Promise((resolve, reject) => {
            this.opts = opts;
            this.setState({
                isOpen: true,
                isLoading: true
            }, () => {
                this.load();
            });
        });
    }

    async load() {
        const stats = await BaseService.callAPI('instructor/get-instructor-credentials-email-stats');
        this.setState({
            stats,
            isLoading: false
        });
    }

    close() {
        this.setState({ isOpen: false });
    }

    async sendEmails(type) {
        this.setState({ sendingType: type });
        const { numSent } = await BaseService.callAPI('instructor/send-instructor-credentials-emails/' + type);
        BootboxHelper.alert(`${numSent} email(s) sent`);
        this.setState({ sendingType: null });
        this.load();
    }

    render() {
        const { isOpen } = this.state;
        if (!isOpen) {
            return null;
        }

        return (
            <Modal show className="instructor-credentials-emails-modal">
                <div className="modal-header">
                    <h5>Instructor Credentials Emails</h5>
                    <button type="button" className="btn btn-secondary ms-auto ms-auto" onClick={() => this.close()}>
                        Close
                    </button>
                </div>
                <Modal.Body>
                    {this.renderInner()}
                </Modal.Body>
            </Modal>
        );
    }
    
    renderInner() {
        const {
            isLoading,
            sendingType,
            stats
        } = this.state;

        if (isLoading) {
            return (<Loader />);
        }

        const rampingCoursesDueStat = stats['ramping-courses-due'];
        const rampingCoursesOverdueStat = stats['ramping-courses-overdue'];
        const rampingDatesMissingStat = stats['ramping-dates-missing'];
        const enablementDatesMissingStat = stats['enablement-dates-missing'];
        const certsExpiringStat = stats['certs-expiring'];

        return (
            <div className="btn-stack">

                <button disabled={!!sendingType} className="btn btn-secondary w-100" onClick={() => this.sendEmails('ramping-courses-due')}>
                    {sendingType == 'RampingCoursesDue' ? <Loader isInline /> : <span className="fa-solid fa-envelope" />}{' '}
                    Ramping courses due this month <br />
                    <span className="schedule">(Sent on 1st Mon/Wed of the month)</span>
                    {rampingCoursesDueStat &&
                        <span className="last-sent">
                            Last sent on {moment(rampingCoursesDueStat.lastSent).format('DD/MM/YYYY')} ({rampingCoursesDueStat.lastSentQuantity} sent)
                        </span>
                    }
                </button>

                <button disabled={!!sendingType} className="btn btn-secondary w-100" onClick={() => this.sendEmails('ramping-courses-overdue')}>
                    {sendingType == 'RampingCoursesOverdue' ? <Loader isInline /> : <span className="fa-solid fa-envelope" />}{' '}
                    Ramping courses overdue <br />
                    <span className="schedule">(Sent on last Fri of month)</span>
                    {rampingCoursesOverdueStat &&
                        <span className="last-sent">
                            Last sent on {moment(rampingCoursesOverdueStat.lastSent).format('DD/MM/YYYY')} ({rampingCoursesOverdueStat.lastSentQuantity} sent)
                        </span>
                    }
                </button>

                <button disabled={!!sendingType} className="btn btn-secondary w-100" onClick={() => this.sendEmails('ramping-dates-missing')}>
                    {sendingType == 'RampingDatesMissing' ? <Loader isInline /> : <span className="fa-solid fa-envelope" />}{' '}
                    Ramping dates missing <br />
                    <span className="schedule">(Sent first Mon/Wed/Fri on/after 15th of month)</span>
                    {rampingDatesMissingStat &&
                        <span className="last-sent">
                            Last sent on {moment(rampingDatesMissingStat.lastSent).format('DD/MM/YYYY')} ({rampingDatesMissingStat.lastSentQuantity} sent)
                        </span>
                    }
                </button>

                <button disabled={!!sendingType} className="btn btn-secondary w-100" onClick={() => this.sendEmails('enablement-dates-missing')}>
                    {sendingType == 'EnablementDatesMissing' ? <Loader isInline /> : <span className="fa-solid fa-envelope" />}{' '}
                    Enablement dates missing <br />
                    <span className="schedule">(Sent first Mon/Wed/Fri on/after 15th of month, Feb/May/Aug/Nov)</span>
                    {enablementDatesMissingStat &&
                        <span className="last-sent">
                            Last sent on {moment(enablementDatesMissingStat.lastSent).format('DD/MM/YYYY')} ({enablementDatesMissingStat.lastSentQuantity} sent)
                        </span>
                    }
                </button>

                <button disabled={!!sendingType} className="btn btn-secondary w-100" onClick={() => this.sendEmails('certs-expiring')}>
                    {sendingType == 'CertsExpiring' ? <Loader isInline /> : <span className="fa-solid fa-envelope" />}{' '}
                    Certifications expiring <br />
                    <span className="schedule">(Sent first Mon/Wed/Fri on/after 15th of month, Jan/Apr/Jul/Oct)</span>
                    {certsExpiringStat &&
                        <span className="last-sent">
                            Last sent on {moment(certsExpiringStat.lastSent).format('DD/MM/YYYY')} ({certsExpiringStat.lastSentQuantity} sent)
                        </span>
                    }
                </button>

            </div>
        );
    }
    
}

export default InstructorCredentialsEmailsModal;